import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import '../styles/custom.css';
import { logoutUser } from '../actions'
//import Payments from './Payments';

// {/*<li key="2"><Payments /></li>,*/}



class Panel extends Component {

	handleLogout(e) {
		this.props.logoutUser(this.props.history);
	}

	render () {
		return (
			<div className="w-100 row" style={{backgroundColor: '#eee', height: '30px'}}>
				<div className="col-lg-8 col-md-8 col-sm-8">
				<span>Eingeloggt als {this.props.user.username}</span>
				&nbsp;| <span><a href="/api/logout">Ausloggen</a></span>
				&nbsp;| <span><Link to="/prefs/password">Passwort ändern</Link></span>
				</div>
			</div>
		);
	}
}

const mapDispatchToProps = {
	logoutUser
}

function mapStateToProps({ auth }) {
	return { auth };
}

export default connect(mapStateToProps, mapDispatchToProps)(Panel);



// WEBPACK FOOTER //
// ./src/components/Panel.js